import * as React from 'react'

function SvgIo(props) {
	return (
		<svg viewBox="0 0 600 300" width="1em" height="1em" {...props}>
			<defs>
				<clipPath id="io_svg__c">
					<path d="M0 0v75h350v75h-50zm300 0H150v200H0v-50z" />
				</clipPath>
				<clipPath id="io_svg__b">
					<path d="M0 0h300v150H0z" />
				</clipPath>
			</defs>
			<path fill="#FFF" d="M0 0h600v300H0z" />
			<path
				id="io_svg__a"
				fill="#002b7f"
				d="M600 260.881c-6.723 4.045-12.499 13.498-30.36 13.498-35.711 0-44.641-19.902-71.427-19.902-17.856 0-26.785 19.902-44.641 19.902-35.715 0-44.643-19.902-71.429-19.902-17.857 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.429-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-23.215 14.182-33.929 14.182v25.621c10.714 0 16.071-14.181 33.929-14.181 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.715 19.901 71.429 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.786-19.901 44.643-19.901 26.786 0 35.714 19.901 71.429 19.901 17.856 0 26.785-19.901 44.641-19.901 26.786 0 35.716 19.901 71.427 19.901 17.861 0 23.637-5.64 30.36-9.684v-29.435z"
			/>
			<use transform="translate(0 -49.753)" xlinkHref="#io_svg__a" />
			<use transform="translate(0 -99.507)" xlinkHref="#io_svg__a" />
			<use transform="translate(0 -149.26)" xlinkHref="#io_svg__a" />
			<use transform="translate(0 -199.014)" xlinkHref="#io_svg__a" />
			<use transform="translate(0 -248.768)" xlinkHref="#io_svg__a" />
			<path fill="#FFF" d="M0 0h300v152H0z" />
			<g clipPath="url(#io_svg__b)">
				<path fill="#00247d" d="M0 0h300v150H0z" />
				<path d="M0 0l300 150m0-150L0 150" stroke="#fff" strokeWidth={30} />
				<path
					d="M0 0l300 150m0-150L0 150"
					stroke="#cf142b"
					strokeWidth={20}
					clipPath="url(#io_svg__c)"
				/>
				<path d="M150 0v200M0 75h350" stroke="#fff" strokeWidth={50} />
				<path d="M150 0v200M0 75h350" stroke="#cf142b" strokeWidth={30} />
			</g>
			<path
				d="M814.961-301.181L797.244 407.48c0 37.298 80.097 37.298 88.583 0L868.11-301.181h-53.149z"
				transform="matrix(.12095 0 0 .28726 347.839 166.046)"
				fill="#a24300"
				strokeWidth={6.935}
				stroke="#fff"
			/>
			<g transform="matrix(.43857 0 0 .37683 122.2 25.058)">
				<g transform="matrix(-.31451 .10485 -.1383 -.30323 1046.472 373.319)">
					<g id="io_svg__d" fill="none" strokeWidth={1} stroke="#000">
						<path
							d="M673.228 325.161l17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.434-35.433 106.3 35.433-35.434-35.433 106.3-17.716 53.15-17.717 17.72-17.716-17.72-17.716-53.15-35.434-106.3 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.716-88.583 35.433 53.15 17.716-70.866z"
							fill="#006d00"
							strokeWidth={8.25}
							stroke="#fff"
						/>
						<path d="M673.228 325.161v496.067M602.362 644.058l70.866 106.3 70.866-106.3" />
						<path d="M602.362 573.192l70.866 106.3 70.866-106.3" />
						<path d="M602.362 502.326l70.866 106.3 70.866-106.3" />
						<path d="M602.362 449.176l70.866 88.583 70.866-88.583" />
						<path d="M602.362 396.027l70.866 88.582 70.866-88.582" />
						<path d="M620.079 342.877l53.15 106.3 53.15-106.3" />
					</g>
				</g>
				<use
					xlinkHref="#io_svg__d"
					transform="matrix(.23652 -.28186 .29496 .22762 354.567 204.654)"
				/>
				<use
					xlinkHref="#io_svg__d"
					transform="matrix(.15164 .33524 -.3329 .1673 907.539 -153.47)"
				/>
				<use
					xlinkHref="#io_svg__d"
					transform="matrix(-.20952 .30246 -.3147 -.19945 1141.363 167.58)"
				/>
				<use
					xlinkHref="#io_svg__d"
					transform="matrix(-.20772 -.25838 .23618 -.23515 689.986 567.277)"
				/>
				<g transform="matrix(-.36218 -.09947 -.2098 .31773 1222.415 -24.23)">
					<g id="io_svg__e" fill="none" strokeWidth={1} stroke="#000">
						<path
							d="M744.095 425.197l28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.25 88.583 35.434-35.433L814.96 708.66l35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.15-17.717 17.72-17.717-17.72-17.716-53.15-35.433-106.3 35.433 35.434-35.433-106.3 35.433 35.434-35.433-106.3 35.433 35.434-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15v-70.866z"
							fill="#006d00"
							strokeWidth={8.25}
							stroke="#fff"
						/>
						<path d="M750.673 460.63l28.855 124.016v336.618" />
						<path d="M719.695 761.81l59.833 88.583 60.682-88.582" />
						<path d="M717.998 690.945l61.53 88.582 60.682-88.582" />
						<path d="M718.846 620.079l60.682 88.582 59.833-88.582" />
						<path d="M716.3 566.929l63.228 70.866 53.149-70.866" />
						<path d="M708.662 513.78l70.866 70.865 45.406-70.865" />
						<path d="M719.589 469.222l53.15 86.886 35.327-95.478" />
					</g>
				</g>
				<use
					xlinkHref="#io_svg__e"
					transform="matrix(.36088 .10411 .01321 .38053 452.761 -239.266)"
				/>
				<g fill="none" stroke="#000">
					<path
						d="M354.331 531.496l88.583 88.583 17.716-53.149v88.582l35.433-35.433-17.716 88.583 35.432-35.434-17.716 88.584 35.433-35.433-17.716 106.299 35.433-35.433-35.433 106.299 35.433-35.433-17.717 106.298-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-53.15-82.294 35.434 11.429-35.433-106.299 35.433 35.433-53.15-106.299 35.433 35.433-53.15-88.584 53.15 35.434-70.866-88.583 53.149 35.433-70.866-70.866 70.866 35.433-53.149-88.583z"
						transform="matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
						fill="#006d00"
						strokeWidth={8.25}
						stroke="#fff"
					/>
					<path
						d="M378.962 560.015l63.952 95.497 17.716 53.15 8.859 45.205 8.858 78.811 9.315 70.866 8.401 141.736"
						transform="matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
					/>
					<path
						d="M425.197 903.544l63.665 70.866 50.749-88.583"
						transform="matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
					/>
					<path
						d="M417.082 814.961l70.579 88.583 50.75-88.583"
						transform="matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
					/>
					<path
						d="M407.48 752.443l70.867 80.235 45.948-88.583M372.047 637.796l88.583 70.866 25.831-70.866"
						transform="matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
					/>
					<path
						d="M360.618 602.363l82.296 53.149 10.515-53.149M389.764 690.945l81.095 70.866 33.946-70.866"
						transform="matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
					/>
				</g>
			</g>
			<g>
				<path
					d="M425.301 222.458l24.962-4.479 26.003 4.479-12.065 5.016-22.258.359-16.642-5.375z"
					fill="#9d9d9d"
					strokeWidth={0.25535664}
					stroke="#000"
				/>
				<path
					d="M450.453 182.12c-4.363 1.517-9.196-2.134-17.064 3.824 0 0-13.717-5.868-14.759 7.694-.041.549 2.172 3.856 2.48 3.62 1.723-1.323-.819 1.285-.819 1.662 0 .38.253.59.339.758.083.17.294.422.336 1.139.042.716-1.554 2.67-.88 3.387.673.717.715 2.783.715 3.372 0 .59.422 2.234.717 2.572.294.336.8 1.179.8 1.895 0 .717.295 2.697.167 3.202-.125.505.759 1.138 1.561 1.39.8.254 11.13.433 25.628.18 14.499-.253 19.336 2.041 25.326-.137.926-.337 1.095-1.095 1.012-1.517-.086-.42 0-1.768.253-2.106.252-.337 1.938-3.034 1.6-3.54.318-.287 2.683 1.366 1.177-.11-.386-.378.216-4.362.424-5.2.21-.841.53-2.42.917-2.713.388-.293-.658-1.39-.584-1.588.075-.2.357-.818.75-1.1 0 0 .731-3.427.28-5.111-.447-1.686-2.095-9.268-12.378-7.75 0 0-13.766-5.294-17.998-3.823z"
					fill="#c00"
					strokeWidth={0.41267457}
					stroke="#000"
				/>
				<g transform="matrix(.27506 0 0 .27506 413.752 163.796)">
					<g
						transform="matrix(.49697 -.0446 .08947 .72677 44.7 100.543)"
						strokeWidth={1.241}
					>
						<g id="io_svg__f" fill="#f7d917" stroke="#000">
							<path d="M49.75.125c-5.093.89-15.156 29.245-12.609 38.75 1.763 6.58 4.498 11.12 6.047 13.906-3.405-4.685-11.383-13.75-22.25-13.75-13.664 0-15.431 29.948-15.094 31.875.001.007-.002.026 0 .032.001.004.029.027.031.031h.031c.613-.715 6.142-13.094 19.657-13.094 8.896 0 15.829 7.035 18.375 10.031-.001.945.022 1.858.031 2.782-2.004 2.828-3.282 9.531-9.469 17.968C27.023 98.852 4.128 99.897.281 100h49.532c.047 0 .109.003.156 0 .022.002.04-.001.062 0 .047.003.109 0 .157 0h49.531c-3.847-.103-27.18-1.148-34.656-11.344-6.188-8.437-7.028-15.14-9.032-17.968.009-.924.032-1.837.032-2.782 2.545-2.996 9.478-10.031 18.375-10.031 13.514 0 19.043 12.379 19.656 13.094h.031c.002-.004.03-.027.031-.031.002-.006-.001-.025 0-.032.337-1.927-1.43-31.875-15.093-31.875-10.868 0-18.846 9.065-22.25 13.75 1.548-2.786 4.29-8.575 5.718-13.906C65.118 29.219 55.091.132 50 .125c-.08 0-.169-.014-.25 0zm-6.437 52.844c.352.49.662.912.906 1.281.005.008.541 2.977.547 2.984-.003.064 2.627 10.186 2.624 10.25-.264-.392-3.737-13.915-4.077-14.515zm13.375 0c-.341.6-4.033 14.123-4.297 14.515-.003-.064 3.393-13.139 3.39-13.203 0-.01-.437 2.964-.437 2.953.244-.369.991-3.775 1.344-4.265z" />
							<path d="M42 67.578s4-1.859 8-1.859 8 1.859 8 1.859v4.953s-4-1.859-8-1.859-8 1.859-8 1.859v-4.953z" />
						</g>
					</g>
					<use
						xlinkHref="#io_svg__f"
						transform="matrix(.49538 .0597 -.0636 .7295 168.919 96.59)"
					/>
					<g fill="#f7d917" strokeWidth={0.715} stroke="#000">
						<path d="M24.308 134.56l9.69-11.814s.903 1.168 0 0C14.132 97.065 13.127 82.331 15.363 74.87c2.236-7.461 6.709-15.544 18.635-25.493 11.926-9.948 20.156-4.419 31.336-4.419 11.181 0 14.163 2.487 23.852 3.731 9.69 1.243 35.778 2.487 35.778 2.487v-6.84s1.029.192 0 0c-11.518-2.147-26.088 0-35.778-2.487-9.689-2.487-17.889-3.108-28.324-3.108-10.435 0-17.92-3.043-24.628 1.31-6.709 4.352-14.908 11.813-20.871 18.031C9.4 64.3 6.419 76.735 7.164 84.818c.746 8.083 3.727 14.923 8.199 21.14 4.473 6.218 3.727 11.192 5.218 15.544 1.491 4.353 3.727 13.679 3.727 13.058zM239.255 134.56l-9.69-11.814s-.904 1.168 0 0c19.865-25.681 20.87-40.415 18.634-47.876-2.236-7.461-6.708-15.544-18.634-25.493-11.926-9.948-20.156-4.419-31.337-4.419-11.181 0-14.162 2.487-23.852 3.731-9.69 1.243-35.778 2.487-35.778 2.487v-6.84s-1.029.192 0 0c11.519-2.147 26.088 0 35.778-2.487 9.69-2.487 17.889-3.108 28.324-3.108 10.436 0 17.92-3.043 24.629 1.31 6.708 4.352 14.907 11.813 20.87 18.031 5.963 6.218 8.945 18.653 8.199 26.736-.745 8.083-3.727 14.923-8.199 21.14-4.472 6.218-3.727 11.192-5.217 15.544-1.491 4.353-3.727 13.679-3.727 13.058z" />
						<path strokeWidth={0.835} d="M115.553 38.701h34.563v70.894h-34.563z" />
					</g>
					<g fill="#f7d917" strokeWidth={0.5} stroke="#000">
						<path d="M119.684-23.799s3.72 3.028 6.575 6.922c2.856 3.893 4.846 8.652 4.846 8.652s-4.759-1.99-8.652-4.846c-3.894-2.855-6.922-6.575-6.922-6.575V6.656s3.028-3.72 6.922-6.575c3.893-2.856 8.652-4.846 8.652-4.846s-1.534 3.927-2.524 8.653c-.891 4.25-8.183 14.064-8.183 14.064l21.303 1.429s-3.542-11.243-4.969-15.493c-1.536-4.578-2.167-8.653-2.167-8.653s4.759 1.99 8.653 4.846c3.893 2.855 6.921 6.575 6.921 6.575v-26.302s-3.028 3.72-6.921 6.575c-3.894 2.856-8.653 4.846-8.653 4.846s1.99-4.759 4.846-8.652c2.855-3.894 6.575-6.922 6.575-6.922h-26.302z" />
						<path d="M149.978 23.076a17.143 17.143 0 11-34.286 0 17.143 17.143 0 1134.286 0z" />
						<path d="M116.074 25.535h34.102s.494-6.596-1.974-9.064h-10.594l-.179-9.888h-10.042l-.179 9.888s-7.127.357-10.41.357c-1.489 4.041-1.26 4.381-1.26 4.381l.536 4.326z" />
					</g>
					<g fill="#f7d917" strokeWidth={0.75} stroke="#000">
						<path d="M110.877 107.221s6.212 5.056 10.979 11.557c4.767 6.501 8.09 14.446 8.09 14.446s-7.946-3.323-14.446-8.09c-6.501-4.767-11.557-10.979-11.557-10.979v43.916s5.056-6.211 11.557-10.979c6.5-4.767 14.446-8.09 14.446-8.09s-3.323 7.946-8.09 14.447c-4.767 6.5-10.979 11.557-10.979 11.557h43.916s-6.212-5.057-10.979-11.557c-4.767-6.501-8.09-14.447-8.09-14.447s7.946 3.323 14.446 8.09c6.501 4.768 11.557 10.979 11.557 10.979v-43.916s-5.056 6.212-11.557 10.979c-6.5 4.767-14.446 8.09-14.446 8.09s3.323-7.945 8.09-14.446c4.767-6.501 10.979-11.557 10.979-11.557h-43.916zM27.24 181.78l21.625-3.813s-6.995-3.901-12.819-9.475c-5.824-5.574-10.476-12.822-10.476-12.822s8.402 1.892 15.632 5.458c7.23 3.566 13.288 8.806 13.288 8.806l-7.626-43.249s-3.901 6.995-9.475 12.819c-5.574 5.824-12.822 10.475-12.822 10.475s1.892-8.401 5.458-15.631c3.566-7.23 8.806-13.288 8.806-13.288l-21.625 3.813L27.24 181.78zM226.839 121.06s5.24 6.058 8.806 13.288c3.566 7.23 5.458 15.631 5.458 15.631s-7.248-4.651-12.822-10.475c-5.574-5.824-9.475-12.819-9.475-12.819l-7.626 43.249s6.058-5.24 13.288-8.806c7.23-3.566 15.632-5.458 15.632-5.458s-4.652 7.248-10.476 12.822c-5.823 5.574-12.819 9.475-12.819 9.475l21.625 3.813 10.034-56.907-21.625-3.813z" />
						<path d="M27.464 179.533l.15 31.506s52.648-17.928 105.296-17.928 105.296 17.928 105.296 17.928v-31.506s-52.685-17.929-105.371-17.929c-52.686 0-105.371 17.929-105.371 17.929z" />
					</g>
					<g fill="#FFF" stroke="#000">
						<g transform="matrix(.66123 0 0 .66123 21.246 -360.32)">
							<path
								id="io_svg__g"
								d="M2.02 723.052a12.122 12.122 0 11-24.243 0 12.122 12.122 0 1124.243 0z"
							/>
						</g>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 10.965 -378.602)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 8.822 -400.03)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 15.25 -420.03)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 28.822 -436.459)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 47.394 -447.887)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 68.108 -446.459)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 88.822 -443.03)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(.66123 0 0 .66123 109.537 -440.887)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 242.316 -360.32)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 252.597 -378.602)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 254.74 -400.03)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 248.312 -420.03)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 234.74 -436.459)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 216.169 -447.887)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 195.454 -446.459)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 174.74 -443.03)"
						/>
						<use
							xlinkHref="#io_svg__g"
							transform="matrix(-.66123 0 0 .66123 154.026 -440.887)"
						/>
						<g transform="translate(1.04)">
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -378.32)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -392.602)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -404.03)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -414.459)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -447.887)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -446.459)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -439.03)"
							/>
							<use
								xlinkHref="#io_svg__g"
								transform="matrix(.66123 0 0 .66123 138.474 -428.887)"
							/>
						</g>
					</g>
					<g fill="#FFF" stroke="#000">
						<g transform="translate(-.457 -2)">
							<path
								id="io_svg__h"
								d="M143.571 136.291a10.357 10.357 0 11-20.714 0 10.357 10.357 0 1120.714 0z"
							/>
						</g>
						<use xlinkHref="#io_svg__h" transform="translate(-108.714 16.786)" />
						<use xlinkHref="#io_svg__h" transform="translate(107.286 16.786)" />
					</g>
				</g>
				<path
					fill="#002b7f"
					strokeWidth={0.21305053}
					stroke="#000"
					d="M446.147 210.405h8.806v3.839h-8.806z"
				/>
				<path
					d="M16.043 233.111a22.995 8.556 0 11-45.99 0 22.995 8.556 0 1145.99 0z"
					transform="matrix(-.1718 -.01744 .00604 .24262 461.52 156.97)"
					fill="#3e8225"
					strokeWidth={1.5}
					stroke="#000"
				/>
				<path
					d="M421.357 215.266l-2.206 2.206 2.559 1.478 5.952-1.595-1.061-3.37-5.244 1.281zM479.743 215.266l2.206 2.206-2.559 1.478-5.951-1.595 1.06-3.37 5.244 1.281z"
					fill="#c00"
					strokeWidth={0.27511638}
					stroke="#000"
				/>
				<path
					d="M16.043 233.111a22.995 8.556 0 11-45.99 0 22.995 8.556 0 1145.99 0z"
					transform="matrix(.1718 -.01744 -.00604 .24262 439.58 156.97)"
					fill="#3e8225"
					strokeWidth={1.5}
					stroke="#000"
				/>
				<g fill="#FFF" stroke="#000" transform="matrix(.25333 0 0 .25333 412 157.18)">
					<g transform="translate(1.07 -3.476)">
						<path
							id="io_svg__i"
							d="M126.203 214.704a4.278 4.278 0 11-8.556 0 4.278 4.278 0 118.556 0z"
						/>
					</g>
					<use xlinkHref="#io_svg__i" transform="translate(2.406 10.16)" />
					<use xlinkHref="#io_svg__i" transform="translate(-52.406 6.15)" />
					<use xlinkHref="#io_svg__i" transform="translate(-47.059 18.984)" />
					<use xlinkHref="#io_svg__i" transform="matrix(-1 0 0 1 303.075 -3.476)" />
					<use xlinkHref="#io_svg__i" transform="matrix(-1 0 0 1 301.738 10.16)" />
					<use xlinkHref="#io_svg__i" transform="matrix(-1 0 0 1 356.55 6.15)" />
					<use xlinkHref="#io_svg__i" transform="matrix(-1 0 0 1 351.203 18.984)" />
				</g>
				<g>
					<path
						d="M472.43 228.267c.827-.144 5.82-1.331 6.872-1.966-.679-1.223-1.896-2.18-.949-1.778.51.216.914-1.47-.567-2.758-4.3 1.41-14.612 3.988-27.57 3.988-13.26 0-23.702-2.713-28.002-4.123-1.481 1.289-1.02 2.752-1.11 3.3 0 .004.002.69.272 1.235 1.457 1.584 6.18 2.364 7.007 2.508 3.89.676 7.779 1.697 21.824 1.697 12.994 0 18.333-1.428 22.223-2.103z"
						fill="#fff"
						strokeWidth={0.43420762}
						stroke="#000"
					/>
					<g transform="matrix(.27506 0 0 .27506 391.394 139.673)">
						<path
							d="M132.906 289.655c-3.009.523-22.147 7.301-25.968 9.61.003.014-.003.045 0 .061.325 1.988-3.322 11.251 2.062 15.935 15.632-5.127 59.525-20.406 106.634-20.406 48.209 0 88.14 15.279 103.772 20.406 5.384-4.684 1.737-13.947 2.063-15.935.003-.016-.004-.047 0-.061-3.822-2.309-22.96-9.087-25.969-9.61-14.14-2.455-28.772-11.586-79.835-11.586-47.237 0-68.619 9.131-82.759 11.586z"
							fill="#fff"
							strokeWidth={1.578}
							stroke="#000"
						/>
						<g transform="matrix(1.38439 -.14324 .15642 1.26776 -86.626 -64.755)">
							<g id="io_svg__k" fill="#000" stroke="#000">
								<g transform="translate(56.864 150.9) scale(.4996)">
									<path
										id="io_svg__j"
										d="M115.508 301.56a1.872 1.872 0 11-3.743 0 1.872 1.872 0 113.743 0z"
									/>
								</g>
								<use
									xlinkHref="#io_svg__j"
									transform="translate(55.527 153.307) scale(.4996)"
								/>
								<use
									xlinkHref="#io_svg__j"
									transform="translate(57.398 154.911) scale(.4996)"
								/>
								<path d="M113.518 303.669l8.526-3.166-4.185 2.392 2.686-.083-2.492 1.168 4.001.275-8.536-.586z" />
							</g>
						</g>
						<use
							xlinkHref="#io_svg__k"
							transform="matrix(1.38439 -.14324 .15642 1.26776 -45.032 -76.658)"
						/>
						<use
							xlinkHref="#io_svg__k"
							transform="matrix(1.37843 .19234 -.15163 1.26835 100.17 -120.86)"
						/>
						<use
							xlinkHref="#io_svg__k"
							transform="matrix(1.38439 .14324 .15642 -1.26776 54.434 659.458)"
						/>
						<use
							xlinkHref="#io_svg__k"
							transform="matrix(1.38439 .14324 .15642 -1.26776 96.412 670.42)"
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}

export default SvgIo
